import { Inject, inject, Injectable, InjectionToken } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppSettings } from '../../../../core/models/settings/app-settings.model';
import { AppSettingsService } from '../../../../core/services/app-settings/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuard {
  constructor(
    private appSettingsService: AppSettingsService,
    @Inject('featurePath') public featurePath: string
  ) { }

  private resolveFeaturePath(object, path, defaultValue): boolean | string {
    return path
      .split('.')
      .reduce((o, p) => (o && o[p] ? o[p] : defaultValue), object);
  }

  canActivate(): Observable<boolean> {
    return this.appSettingsService.appSettings$.pipe(
      map((appSettings: AppSettings) => {
        const flagValue = this.resolveFeaturePath(
          appSettings,
          this.featurePath,
          false
        );
        return flagValue === true || flagValue === 'true';
      })
    );
  }

  static canActivateWithFeature(featurePath: string): InjectionToken<{
    canActivate: CanActivateFn;
  }> {
    return new InjectionToken<{
      canActivate: CanActivateFn;
    }>('FeatureGuardWithFeature', {
      providedIn: 'root',
      factory: () => new FeatureGuard(inject(AppSettingsService), featurePath)
    });
  }
}
